var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.383 1.006V.671c0-.16.129-.288.288-.288h1.342L2.126.16C2.173.061 2.273 0 2.382 0h1.37c.108 0 .208.061.257.16l.113.223h1.342c.159 0 .287.129.287.288v.335c0 .08-.065.144-.144.144H.527c-.079 0-.144-.064-.144-.144zm4.975.68l-.244 3.91c-.02.303-.271.539-.574.539H1.595c-.303 0-.555-.236-.574-.54l-.245-3.91c-.004-.082.062-.151.144-.151h4.296c.081 0 .147.07.142.152z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8c6db9067b089688f6cd9a811105766c.svg";
export { ForwardRef as ReactComponent };